import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Breadcrumb, Row, Select, Button, Tooltip } from 'antd';
import message from 'antd/lib/message';
import { Link } from 'react-router-dom';
import get from 'lodash/get';
import moment from 'moment';
import { permissionService } from 'shared/services';
import { formatMoney, formatDateTime } from 'shared/utils/StringUtil';
import NewFilter from 'components/NewFilter/NewFilter.container';
import Table from 'components/Table/Table.component';
import { FILTER_TYPE } from 'shared/constant';
import text from './TransactionLog.page.translation';
import goldRoute from '../../route';
import { initialState } from '../../redux/reducers/goldReducer';
import {
  STATUS,
  STATE_OPTIONS,
  STATE,
  PAYMENT_OPTION,
} from '../../constant/GoldDefaultVar';

import './TransactionLog.style.less';
const { checkPermission } = permissionService;
const { Option } = Select;
export default class TransactionLog extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      currentFilter: [],
    };
    this.props.resetFilter();
  }

  componentDidMount = () => {
    const { getListTransactions } = this.props;
    const paginationUrl = this.buildPaginationUrl(initialState.trxFilter);
    getListTransactions(paginationUrl);
  };

  renderBreadCrumb = () => {
    const {
      intl: { formatMessage },
    } = this.props;
    return (
      <Row className="breadcrumb-wrapper">
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to="/">{formatMessage(text.home)}</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>{formatMessage(text.page)}</Breadcrumb.Item>
        </Breadcrumb>
      </Row>
    );
  };

  renderNoColumn = (pageNum, pageSize) => (_text, _record, index) => {
    const result = index + 1 + pageSize * (pageNum - 1);
    return result;
  };

  _renderFormattedColumn = (format, item) => t => format(get(t, item));

  renderTrxDate = (_text, record) =>
    moment(record.created_at).format('D - MMM - YYYY');

  renderAmountIDR = key => (_text, record) => {
    const amount = get(record, key);
    return `${formatMoney(amount.substring(0, amount.length - 3))}`;
  };

  getStatusColor = status => {
    let color = '';
    let colorCode = '';
    switch (status) {
      case STATE[0]:
      case STATE[1]:
      case STATE[2]:
      case STATE[3]:
        color = 'orange';
        colorCode = '#ff9e30';
        break;
      case STATE[4]:
      case STATE[5]:
      case STATE[6]:
        color = 'red';
        colorCode = '#fa6060';
        break;
      case STATE[7]:
      case STATE[8]:
        color = 'green';
        colorCode = '#5ace70';
        break;
      default:
        color = 'grey';
        colorCode = '#9b9b9b';
        break;
    }

    return { color, colorCode };
  };

  updateStatusSuccess = result => {
    if (result === 'success') {
      message.success({
        content: 'Update Status Succeeded',
        key: 'updateStatus',
      });
      this.refreshTable();
    } else {
      this.updateStatusFailed();
    }
  };

  updateStatusFailed = () => {
    message.error({
      content: 'Update Status Failed',
      key: 'updateStatus',
    });
  };

  onUpdateStatus = id => value => {
    this.props
      .updateStatus(id, value)
      .then(this.updateStatusSuccess)
      .catch(this.updateStatusFailed);
  };

  renderStatus = (_text, record) => {
    const {
      intl: { formatMessage },
    } = this.props;
    if (
      checkPermission('Transaction Log:update') &&
      record.state === 'IN_PROGRESS'
    ) {
      return (
        <Select
          value={record.state}
          bordered={false}
          style={{
            width: 140,
            color: this.getStatusColor(record.state).colorCode,
          }}
          onChange={this.onUpdateStatus(record.id)}
        >
          {STATE_OPTIONS.map(state => (
            <Option
              key={`key-${state}`}
              value={state}
              className={this.getStatusColor(state).color}
            >
              {formatMessage({ id: `gold.state.${state}` })}
            </Option>
          ))}
        </Select>
      );
    }
    return (
      <span className={`status ${this.getStatusColor(record.state).color}`}>
        {record.status}
      </span>
    );
  };

  refreshTable = () => {
    const { getListTransactions, trxFilter } = this.props;
    const newPagination = {
      ...trxFilter,
      page_num: 1,
    };
    const paginationUrl = this.buildPaginationUrl(newPagination);
    const paramUrl = this.buildGetParamUrl(this.state.currentFilter);
    getListTransactions(paginationUrl, paramUrl);
  };

  successRetryDisburse = result => {
    if (result === 'success') {
      message.success({
        content: 'Retry Disburse Succeeded',
        key: 'disburse',
      });
      this.refreshTable();
    } else {
      this.failedRetryDisburse();
    }
  };

  failedRetryDisburse = () => {
    message.error({
      content: 'Retry Disburses Failed',
      key: 'updateStatus',
    });
  };

  actionDisburse = id => () => {
    this.props
      .manualDisburse(id)
      .then(this.successRetryDisburse)
      .catch(this.failedRetryDisburse);
  };

  renderManualDisburse = (_text, record) => {
    const {
      intl: { formatMessage },
    } = this.props;
    if (record.state === STATE[0] && record.status === STATUS[4]) {
      return (
        <Button type="primary" onClick={this.actionDisburse(record.id)}>
          {formatMessage(text.disburse.retry)}
        </Button>
      );
    }
    return (
      <Button disabled type="primary">
        {formatMessage(text.disburse.noRetry)}
      </Button>
    );
  };

  _handlerGoToDetail = record => {
    this.props.resetFilter();
    this.props.history.push(
      goldRoute.TRANSACTION_DETAIL.replace(':id', record.dana_public_id),
    );
  };

  renderDetails = key => record => {
    const getValue = get(record, key, '');
    if (getValue) {
      return (
        <button
          type="button"
          className="btn-details left-text"
          onClick={() => {
            this._handlerGoToDetail(record);
          }}
        >
          <Tooltip placement="topLeft" title={getValue}>
            <span>{getValue}</span>
          </Tooltip>
        </button>
      );
    }
    return `-`;
  };

  renderColumns = (pageNum, pageSize, formatMessage) => [
    {
      title: formatMessage(text.table.no),
      key: 'index',
      render: this.renderNoColumn(pageNum, pageSize),
      width: 80,
      align: 'center',
    },
    {
      title: formatMessage(text.table.public),
      key: 'danaPublicId',
      width: 250,
      render: this.renderDetails('dana_public_id'),
    },
    {
      title: formatMessage(text.table.merchant),
      key: 'merchantID',
      width: 200,
      render: this.renderDetails('public_id'),
    },
    {
      title: formatMessage(text.table.phone),
      key: 'phoneNumber',
      dataIndex: 'phone_number',
      width: 200,
      align: 'center',
    },
    {
      title: formatMessage(text.table.trxDate),
      key: 'created_at',
      width: 220,
      align: 'center',
      render: this._renderFormattedColumn(formatDateTime, 'created_at'),
    },
    {
      title: formatMessage(text.table.trxType),
      key: 'trxType',
      dataIndex: 'trx_order_type',
      width: 160,
      align: 'center',
    },
    {
      title: formatMessage(text.table.paymentOption),
      key: 'payment_option',
      dataIndex: 'payment_option',
      width: 160,
      align: 'center',
    },
    {
      title: formatMessage(text.table.gram),
      key: 'amountGram',
      dataIndex: 'item_quantity',
      width: 120,
      align: 'center',
    },
    {
      title: formatMessage(text.table.idr),
      key: 'amountGramTrx',
      render: this.renderAmountIDR('trx_total_amount'),
      width: 200,
      align: 'center',
    },
    {
      title: formatMessage(text.table.fee),
      key: 'fee',
      render: this.renderAmountIDR('trx_fee_amount'),
      width: 160,
      align: 'center',
    },
    {
      title: formatMessage(text.table.state),
      key: 'state',
      dataIndex: 'state',
      align: 'center',
      width: 200,
    },
    {
      title: formatMessage(text.table.status),
      key: 'status',
      render: this.renderStatus,
      align: 'center',
      width: 200,
    },
    {
      title: formatMessage(text.table.action),
      key: 'action',
      render: this.renderManualDisburse,
      align: 'center',
      width: 200,
    },
  ];

  getColumnsScrollX = columns => {
    const result = columns
      .map(x => x.width)
      .reduce((prev, next) => prev + next);
    return result;
  };

  getRowKey = record => record.id;

  handleChangePage = page => {
    const { trxFilter, filterValue, getListTransactions } = this.props;
    const newPagination = {
      ...trxFilter,
      page_num: page,
    };
    const paginationUrl = this.buildPaginationUrl(newPagination);
    const paramUrl = this.buildGetParamUrl(filterValue);
    getListTransactions(paginationUrl, paramUrl);
  };

  buildGetParamUrl = filterValue => {
    let result = '';

    filterValue.forEach(element => {
      const value = element.inputValue[0];

      switch (element.key) {
        case 'trx_date':
          result += `&created_from=${value}&created_until=${
            element.inputValue[1]
          }`;
          break;
        case 'amount_gram':
          result += `&amount_gram_from=${value}&amount_gram_until=${
            element.inputValue[1]
          }`;
          break;
        case 'amount_idr':
          result += `&amount_idr_from=${value}&amount_idr_until=${
            element.inputValue[1]
          }`;
          break;
        case 'fee':
          result += `&fee_from=${value}&fee_until=${element.inputValue[1]}`;
          break;
        default:
          result += `&${element.key}=${value}`;
          break;
      }
    });

    return result;
  };

  buildPaginationUrl = trxFilter => {
    let result = '';
    result += `page_size=${encodeURIComponent(trxFilter.page_size)}`;
    result += `&page_count=${encodeURIComponent(trxFilter.page_count)}`;
    result += `&page_num=${encodeURIComponent(trxFilter.page_num)}`;

    return result;
  };

  updateTransactionTable = newFilterValue => {
    const { getListTransactions, trxFilter } = this.props;

    const newPagination = {
      ...trxFilter,
      page_num: 1,
    };
    const paginationUrl = this.buildPaginationUrl(newPagination);
    const paramUrl = this.buildGetParamUrl(newFilterValue);
    this.setState({ currentFilter: newFilterValue }, () => {
      getListTransactions(paginationUrl, paramUrl);
    });
  };

  render() {
    const {
      intl: { formatMessage },
      loading,
      trxList,
      trxFilter,
    } = this.props;

    const pageSize = get(trxFilter, 'page_size');
    const pageCount = get(trxFilter, 'page_count');
    const pageNum = get(trxFilter, 'page_num');
    const totalItem = pageSize * pageCount;
    const tableColumns = this.renderColumns(pageNum, pageSize, formatMessage);
    const scrollX = this.getColumnsScrollX(tableColumns);

    const options = [
      {
        label: formatMessage(text.table.public),
        value: 'dana_public_id',
        type: FILTER_TYPE.TEXT,
      },
      {
        label: formatMessage(text.table.phone),
        value: 'phone_number',
        type: FILTER_TYPE.TEXT,
      },
      {
        label: formatMessage(text.table.merchant),
        value: 'public_id',
        type: FILTER_TYPE.TEXT,
      },
      {
        label: formatMessage(text.table.trxDate),
        value: 'trx_date',
        options: {
          showTime: false,
          format: 'YYYY-MM-DD',
        },
        type: FILTER_TYPE.RANGE_PICKER,
      },
      {
        label: formatMessage(text.table.trxType),
        value: 'transaction_type',
        type: FILTER_TYPE.RADIO,
        options: [
          { label: 'BUY', value: 'BUY' },
          { label: 'SELL', value: 'SELL' },
        ],
      },
      {
        label: formatMessage(text.table.gram),
        value: 'amount_gram',
        type: FILTER_TYPE.RANGE_INPUT,
        options: {
          minLabel: formatMessage(text.validation.min),
          maxLabel: formatMessage(text.validation.max),
          range: [0, 1000],
          float: true,
          step: 0.01,
          unit: 'gr',
        },
      },
      {
        label: formatMessage(text.table.paymentOption),
        value: 'payment_option',
        type: FILTER_TYPE.RADIO,
        options: PAYMENT_OPTION.map(status => ({
          label: status,
          value: status,
        })),
      },
      {
        label: formatMessage(text.table.idr),
        value: 'amount_idr',
        type: FILTER_TYPE.RANGE_INPUT,
        options: {
          minLabel: formatMessage(text.validation.min),
          maxLabel: formatMessage(text.validation.max),
          range: [0, 100000000],
          step: 1000,
          formater: formatMoney,
        },
      },
      {
        label: formatMessage(text.table.fee),
        value: 'fee',
        type: FILTER_TYPE.RANGE_INPUT,
        options: {
          minLabel: formatMessage(text.validation.min),
          maxLabel: formatMessage(text.validation.max),
          range: [0, 100000000],
          step: 1000,
          formater: formatMoney,
        },
      },
      {
        label: formatMessage(text.table.status),
        value: 'status',
        type: FILTER_TYPE.RADIO,
        options: STATUS.map(status => ({
          label: status,
          value: status,
        })),
      },
      {
        label: formatMessage(text.table.state),
        value: 'state',
        type: FILTER_TYPE.RADIO,
        options: STATE.map(state => ({
          label: state,
          value: state,
        })),
      },
    ];

    return (
      <div id="trx-log-gold" className="main-content transactions-page">
        {this.renderBreadCrumb()}

        <div className="white-box-wrapper">
          <div className="title mbottom30 title-trx">
            <div className="title-trx-left">
              {formatMessage(text.transactionsTitle)}
            </div>
          </div>

          <NewFilter
            options={options}
            onAddFilter={this.updateTransactionTable}
            onRemoveFilter={this.updateTransactionTable}
          />
          <div className="table-wrapper">
            <Table
              bordered
              columns={tableColumns}
              dataSource={trxList}
              pagination="true"
              rowKey={this.getRowKey}
              rowClass="striped-table"
              loadingValue={loading}
              totalItem={totalItem}
              currentPage={pageNum}
              changePage={this.handleChangePage}
              scrollX={scrollX}
            />
          </div>
        </div>
      </div>
    );
  }
}

TransactionLog.propTypes = {
  intl: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  trxList: PropTypes.array,
  trxFilter: PropTypes.object,
  filterValue: PropTypes.array,
  getListTransactions: PropTypes.func.isRequired,
  resetFilter: PropTypes.func.isRequired,
  updateStatus: PropTypes.func.isRequired,
  manualDisburse: PropTypes.func.isRequired,
  history: PropTypes.object,
};
